import React from 'react';
import { useAsyncDebounce } from 'react-table';
import { useLocation } from 'react-router-dom';
import Csv from 'assets/images/csv-icon.svg';
import Excel from 'assets/images/xls-icon.svg';
import AddUser from 'assets/images/ic-users-add.svg';

import Button from '../button';
import NewInput from '../NewInput';
import Search from '../search';
import { LocalStorage } from 'app/utils/storage';
import { LocalSessionKey } from 'app/constants/app-constants';
const SectionHeader = ({
  sectionObj,
  searchVal,
  handleSearch,
  customerData,
}) => {
  // Debounced search handler

  const location = useLocation(); // Get the current route
  const userType = LocalStorage.get(LocalSessionKey.ROLE);
  const user = JSON.parse(LocalStorage.get(LocalSessionKey.USER_INFO));
  const onSearch = useAsyncDebounce((val) => {
    handleSearch && handleSearch(val);
  }, 2000); // 1000ms debounce delay

  if (!sectionObj) return null;

  const { sectionTitle, searchObj, buttons, downloadObj } = sectionObj;

  return (
    <>
      {sectionTitle && <h4>{sectionTitle}</h4>}
      <div className='content-container__actionBox'>
        <>
          {searchObj && (
            <div className='content-container__filterSearch'>
              <Search
                placeholder={searchObj?.placeholder}
                onChange={onSearch}
                value={searchVal}
              />
            </div>
          )}
          <div>
            {buttons &&
              buttons?.map((btnObj, index) =>
                location.pathname === '/mall' && user?.type !== 'su' ? (
                  <></>
                ) : (
                  <Button
                    className={btnObj?.customclassName}
                    key={`${index}_${btnObj.title}`}
                    isDisabled={btnObj?.isDisabled}
                    onClick={(e) =>
                      btnObj.handleBtnClick && btnObj.handleBtnClick(e)
                    }
                  >
                    {btnObj?.imgTrue && <img src={AddUser} alt='add-user' />}

                    {btnObj.title}
                    {btnObj.children && btnObj.children()}
                  </Button>
                )
              )}
            {downloadObj && (
              <>
                {/* `downloadObj.inProgress` toggles the in-flight visual state:
                    icons dim + cursor changes, plus a small "Generating..."
                    indicator. Clicks pass through to the hook, which guards
                    against double-fire via its internal ref. Each icon renders
                    only when its handler exists, so a page can offer a single
                    format (e.g. bill validation is excel-only). */}
                {downloadObj.csvClick && (
                  <span
                    className='link cursor-pointer download'
                    style={
                      downloadObj.inProgress
                        ? { opacity: 0.5, cursor: 'not-allowed' }
                        : undefined
                    }
                    onClick={(e) =>
                      !downloadObj.inProgress && downloadObj.csvClick(e)
                    }
                  >
                    <img alt={'csv'} src={Csv} />
                  </span>
                )}
                {downloadObj.excelClick && (
                  <span
                    className='link cursor-pointer download'
                    style={
                      downloadObj.inProgress
                        ? { opacity: 0.5, cursor: 'not-allowed' }
                        : undefined
                    }
                    onClick={(e) =>
                      !downloadObj.inProgress && downloadObj.excelClick(e)
                    }
                  >
                    <img alt={'excel'} src={Excel} />
                  </span>
                )}
                {downloadObj.inProgress && (
                  <span
                    style={{
                      marginLeft: 8,
                      fontSize: '0.85rem',
                      color: '#666',
                      fontStyle: 'italic',
                    }}
                  >
                    Generating report…
                  </span>
                )}
              </>
            )}
          </div>
        </>
      </div>

      {customerData === null && (
        <small className='hideNextDiv'>
          Enter a valid customer phone number to load the data.
        </small>
      )}
      {customerData && (
        <div className='inner-form-wrapper flex justify-between flex-wrap mb-4'>
          <strong className='wd-100 mb-2'>Contact Information</strong>
          <div className='wd-33'>
            <NewInput
              label='Name'
              id='name'
              type='text'
              placeholder='Name'
              name='name'
              value={customerData?.name || ''}
              disabled
            />
          </div>
          <div className='wd-33'>
            <NewInput
              label='Phone Number'
              id='number'
              type='text'
              placeholder='Phone Number'
              name='number'
              value={customerData?.phone || ''}
              disabled
            />
          </div>
          <div className='wd-33'>
            <NewInput
              label='Email Address'
              id='email'
              type='text'
              placeholder='Email Address'
              name='email'
              value={customerData?.email || ''}
              disabled
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SectionHeader;
